
import {defineComponent} from 'vue'
import { ReportChart } from '@/model/models'
import { Chart, registerables } from 'chart.js'
import { BubbleChart } from 'vue-chart-3'

Chart.register(...registerables)

export default defineComponent( {
  name: 'ReportBubbleChart',
  components: {
    BubbleChart
  },
  props: {
    chart: ReportChart,
    chartData: {}
  },
  data () {
    return {
      chartOptions: {
        // For chart options see https://www.chartjs.org/docs
        responsive: true,
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            padding: 10,
            boxPadding: 10
          },
          datalabels: {
            // For label options see https://chartjs-plugin-datalabels.netlify.app
            display: false
          }
        }
      }
    }
  }
})
